import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Deals from './Deals';
import DealTiles from './DealTiles';
import {API} from '@aws-amplify/core';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';

import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { removeDollarSignAndCommas, capitalizeFirstLetter } from '../../helper';

import Hidden from '@material-ui/core/Hidden';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import StarIcon from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import SettingsIcon from '@material-ui/icons/Settings';
import EmailIcon from '@material-ui/icons/Email';
import CarIcon from '@material-ui/icons/DirectionsCar';
import ReportIcon from '@material-ui/icons/Report';
import FilterListIcon from '@material-ui/icons/FilterList';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import VanIcon from '@material-ui/icons/AirportShuttle';
import ThumbsUpIcon from '@material-ui/icons/ThumbUp';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import SearchIcon from '@material-ui/icons/Search';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';

import { createBrowserHistory } from 'history';

import queryString from 'query-string';

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 0 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const drawerWidth = 240;

const styles = theme => ({
  root: {
    width: '100%'
  },
  appBar: {
    width: '100%',
    //backgroundColor: theme.palette.primary.dark,
  },
  tabs: {
    backgroundColor: "#ffffff",
    textColor: theme.palette.primary.dark,
    selectedTextColor: "#ffffff"
  },
  input: {
    marginLeft: theme.spacing.unit * 1,
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  textField: {
    //flexBasis: 200,
    width: '100%',
    marginLeft: 12,
    border: '1px',
  },
  drawerHeader: theme.mixins.toolbar,
  drawerPaper: {
    //backgroundColor: theme.palette..secondary.light, //"#f9e06c",
    marginTop: 57,
    width: drawerWidth,
    [theme.breakpoints.up('sm')]: {
      position: 'fixed',
    },
  },
  drawerPaperFilter: {
    //backgroundColor: theme.palette..secondary.light, //"#f9e06c",
    marginTop: 76,
    marginLeft: '16.66%',
    width: drawerWidth,
    [theme.breakpoints.up('sm')]: {
      position: 'fixed',
    },
  },
  content: {
    //backgroundColor: theme.palette.background.default,
    width: '100%',
    //padding: theme.spacing.unit * 3,
    height: 'calc(100% - 16px)',
    marginTop: 24,
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 24px)',
      marginTop: 36,
      //marginLeft: -20,
    },
    overflow: 'auto'
  },
  starCheckbox: {
    margin: theme.spacing.unit * 1,
  },
  textField: {
    //flexBasis: 200,
    width: '80%',
    [theme.breakpoints.up('lg')]: {
      width: '100%',
    },
    marginTop: 20,
    marginLeft: 12,
    border: '1px',
  },
  button: {
    margin: theme.spacing.unit,
  },
  navIconHide: {
    marginTop: -20,
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
});

class FilteredDeals extends React.Component {

  constructor(props) {
    super(props);
    //console.log('FilteredDeals constructor()...');
    const values = queryString.parse(this.props.location.search)
    if (values.filter === "y") {
      console.log('filter is y');
      let default_make_filter = true;
      if (values.filterByMake) //just set filterbyMake to something then specify the make(s) you want
        default_make_filter = false;
      this.state = {
        mobileOpen: false,
        allLocalDeals: this.props.allLocalDeals,
        resultingDeals: [],//this.sortAndSlice(this.props.allLocalDeals),
        //filters
        star1: (values.star1) ? (values.star1 === "true") : true,
        star2: (values.star2) ? (values.star2 === "true") : true,
        star3: (values.star3) ? (values.star3 === "true") : true,
        star4: (values.star4) ? (values.star4 === "true") : true,
        star5: (values.star5) ? (values.star5 === "true") : true,
        maxPayment: (values.maxPayment) ? values.maxPayment : 2000,
        // bodyTypeSUV=true&bodyTypeTruck=false&bodyTypeCoupe=false&bodyTypeSedan=true&bodyTypeMinivan=true&bodyTypeHatchback=false&bodyTypeConvertible=false
        bodyTypeSedan: (values.bodyTypeSedan) ? (values.bodyTypeSedan === "true") : true,
        bodyTypeCoupe: (values.bodyTypeCoupe) ? (values.bodyTypeCoupe === "true") : true,
        bodyTypeConvertible: (values.bodyTypeConvertible) ? (values.bodyTypeConvertible === "true") : true,
        bodyTypeSUV: (values.bodyTypeSUV) ? (values.bodyTypeSUV === "true") : true,
        bodyTypeHatchback: (values.bodyTypeHatchback) ? (values.bodyTypeHatchback === "true") : true,
        bodyTypeMinivan: (values.bodyTypeMinivan) ? (values.bodyTypeMinivan === "true") : true,
        bodyTypeTruck: (values.bodyTypeTruck) ? (values.bodyTypeTruck === "true") : true,
        //type params
        typeHydrogenFuelCell: (values.typeHydrogenFuelCell) ? (values.typeHydrogenFuelCell === "true") : true,
        typeElectric: (values.typeElectric) ? (values.typeElectric === "true") : true,
        typeHybrid: (values.typeHybrid) ? (values.typeHybrid === "true") : true,
        typeGasoline: (values.typeGasoline) ? (values.typeGasoline === "true") : true,
        //sort
        sortOrder: "rating", //or "rating"
        //make params
        makeHonda: (values.makeHonda) ? (values.makeHonda === "true") : default_make_filter,
        makeToyota: (values.makeToyota) ? (values.makeToyota === "true") : default_make_filter,
        makeAudi: (values.makeAudi) ? (values.makeAudi === "true") : default_make_filter,
        makeBMW: (values.makeBMW) ? (values.makeBMW === "true") : default_make_filter,
        makeChevrolet: (values.makeChevrolet) ? (values.makeChevrolet === "true") : default_make_filter,
        makeKia: (values.makeKia) ? (values.makeKia === "true") : default_make_filter,
        makeLandRover: (values.makeLandRover) ? (values.makeLandRover === "true") : default_make_filter,
        makeVolkswagen: (values.makeVolkswagen) ? (values.makeVolkswagen === "true") : default_make_filter,
        makeLexus: (values.makeLexus) ? (values.makeLexus === "true") : default_make_filter,
        makeNissan: (values.makeNissan) ? (values.makeNissan === "true") : default_make_filter,
        makeFord: (values.makeFord) ? (values.makeFord === "true") : default_make_filter,
        makeInfiniti: (values.makeInfiniti) ? (values.makeInfiniti === "true") : default_make_filter,
        makeMercedes: (values.makeMercedes) ? (values.makeMercedes === "true") : default_make_filter,
        makeHyundai: (values.makeHyundai) ? (values.makeHyundai === "true") : default_make_filter,
        makeLincoln: (values.makeLincoln) ? (values.makeLincoln === "true") : default_make_filter,
        makeJaguar: (values.makeJaguar) ? (values.makeJaguar === "true") : default_make_filter,
        makeAcura: (values.makeAcura) ? (values.makeAcura === "true") : default_make_filter,
        makeAlfaRomeo: (values.makeAlfaRomeo) ? (values.makeAlfaRomeo === "true") : default_make_filter,
        //search
        searchByMakeModel: (values.searchByMakeModel) ? values.searchByMakeModel : '',
        carMakes: [
          {name: "Acura", stateName: "makeAcura"},
          {name: "Audi", stateName: "makeAudi"},
          {name: "BMW", stateName: "makeBMW"},
          {name: "Honda", stateName: "makeHonda"},
          {name: "Toyota", stateName: "makeToyota"},
          {name: "Kia", stateName: "makeKia"},
          {name: "Land Rover", stateName: "makeLandRover"},
          {name: "Chevrolet", stateName: "makeChevrolet"},
          {name: "Lexus", stateName: "makeLexus"},
          {name: "Mercedes", stateName: "makeMercedes"},
          {name: "Nissan", stateName: "makeNissan"},
          {name: "Ford", stateName: "makeFord"},
          {name: "Infiniti", stateName: "makeInfiniti"},
          {name: "Hyundai", stateName: "makeHyundai"},
          {name: "Lincoln", stateName: "makeLincoln"},
          {name: "Jaguar", stateName: "makeJaguar"},
          {name: "Volkswagen", stateName: "makeVolkswagen"},
          {name: "Alfa Romeo", stateName: "makeAlfaRomeo"},
        ],
        //sample for 5-star bmw deals:
        //star5=true&typeHydrogenFuelCell=true&typeElectric=true&typeHybrid=true&typeGasoline=true&makeBMW=true
      }
    } else {
      this.state = {
        mobileOpen: false,
        allLocalDeals: this.props.allLocalDeals,
        resultingDeals: this.sortAndSlice(this.props.allLocalDeals),
        //filter fields
        star1: (sessionStorage.getItem('star1') === null) ? true : (sessionStorage.getItem('star1') === "true"),
        star2: (sessionStorage.getItem('star2') === null) ? true : (sessionStorage.getItem('star2') === "true"),
        star3: (sessionStorage.getItem('star3') === null) ? true : (sessionStorage.getItem('star3') === "true"),
        star4: (sessionStorage.getItem('star4') === null) ? true : (sessionStorage.getItem('star4') === "true"),
        star5: (sessionStorage.getItem('star5') === null) ? true : (sessionStorage.getItem('star5') === "true"),
        maxPayment: (sessionStorage.getItem('maxPayment') === null) ? 2000 : (sessionStorage.getItem('maxPayment')),
        bodyTypeSedan: (sessionStorage.getItem('bodyTypeSedan') === null) ? true : (sessionStorage.getItem('bodyTypeSedan') === "true"),
        bodyTypeCoupe: (sessionStorage.getItem('bodyTypeCoupe') === null) ? true : (sessionStorage.getItem('bodyTypeCoupe') === "true"),
        bodyTypeConvertible: (sessionStorage.getItem('bodyTypeConvertible') === null) ? true : (sessionStorage.getItem('bodyTypeConvertible') === "true"),
        bodyTypeSUV: (sessionStorage.getItem('bodyTypeSUV') === null) ? true : (sessionStorage.getItem('bodyTypeSUV') === "true"),
        bodyTypeHatchback: (sessionStorage.getItem('bodyTypeHatchback') === null) ? true : (sessionStorage.getItem('bodyTypeHatchback') === "true"),
        bodyTypeMinivan: (sessionStorage.getItem('bodyTypeMinivan') === null) ? true : (sessionStorage.getItem('bodyTypeMinivan') === "true"),
        bodyTypeTruck: (sessionStorage.getItem('bodyTypeTruck') === null) ? true : (sessionStorage.getItem('bodyTypeTruck') === "true"),
        //type params
        typeHydrogenFuelCell: (sessionStorage.getItem('typeHydrogenFuelCell') === null) ? true : (sessionStorage.getItem('typeHydrogenFuelCell') === "true"),
        typeElectric: (sessionStorage.getItem('typeElectric') === null) ? true : (sessionStorage.getItem('typeElectric') === "true"),
        typeHybrid: (sessionStorage.getItem('typeHybrid') === null) ? true : (sessionStorage.getItem('typeHybrid') === "true"),
        typeGasoline: (sessionStorage.getItem('typeGasoline') === null) ? true : (sessionStorage.getItem('typeGasoline') === "true"),
        sortOrder: (sessionStorage.getItem('sortOrder') === null) ? "rating" : sessionStorage.getItem('sortOrder'), //or "rating"
        makeHonda: (sessionStorage.getItem('makeHonda') === null) ? true : (sessionStorage.getItem('makeHonda') === "true"),
        makeToyota: (sessionStorage.getItem('makeToyota') === null) ? true : (sessionStorage.getItem('makeToyota') === "true"),
        makeAudi: (sessionStorage.getItem('makeAudi') === null) ? true : (sessionStorage.getItem('makeAudi') === "true"),
        makeBMW: (sessionStorage.getItem('makeBMW') === null) ? true : (sessionStorage.getItem('makeBMW') === "true"),
        makeChevrolet: (sessionStorage.getItem('makeChevrolet') === null) ? true : (sessionStorage.getItem('makeChevrolet') === "true"),
        makeKia: (sessionStorage.getItem('makeKia') === null) ? true : (sessionStorage.getItem('makeKia') === "true"),
        makeLandRover: (sessionStorage.getItem('makeLandRover') === null) ? true : (sessionStorage.getItem('makeLandRover') === "true"),
        makeVolkswagen: (sessionStorage.getItem('makeVolkswagen') === null) ? true : (sessionStorage.getItem('makeVolkswagen') === "true"),
        makeLexus: (sessionStorage.getItem('makeLexus') === null) ? true : (sessionStorage.getItem('makeLexus') === "true"),
        makeNissan: (sessionStorage.getItem('makeNissan') === null) ? true : (sessionStorage.getItem('makeNissan') === "true"),
        makeFord: (sessionStorage.getItem('makeFord') === null) ? true : (sessionStorage.getItem('makeFord') === "true"),
        makeInfiniti: (sessionStorage.getItem('makeInfiniti') === null) ? true : (sessionStorage.getItem('makeInfiniti') === "true"),
        makeMercedes: (sessionStorage.getItem('makeMercedes') === null) ? true : (sessionStorage.getItem('makeMercedes') === "true"),
        makeHyundai: (sessionStorage.getItem('makeHyundai') === null) ? true : (sessionStorage.getItem('makeHyundai') === "true"),
        makeLincoln: (sessionStorage.getItem('makeLincoln') === null) ? true : (sessionStorage.getItem('makeLincoln') === "true"),
        makeJaguar: (sessionStorage.getItem('makeJaguar') === null) ? true : (sessionStorage.getItem('makeJaguar') === "true"),
        makeAcura: (sessionStorage.getItem('makeAcura') === null) ? true : (sessionStorage.getItem('makeAcura') === "true"),
        makeAlfaRomeo: (sessionStorage.getItem('makeAlfaRomeo') === null) ? true : (sessionStorage.getItem('makeAlfaRomeo') === "true"),
        searchByMakeModel: (sessionStorage.getItem('searchByMakeModel') === null) ? '' : sessionStorage.getItem('searchByMakeModel'),
        carMakes: [
          {name: "Acura", stateName: "makeAcura"},
          {name: "Audi", stateName: "makeAudi"},
          {name: "BMW", stateName: "makeBMW"},
          {name: "Honda", stateName: "makeHonda"},
          {name: "Toyota", stateName: "makeToyota"},
          {name: "Kia", stateName: "makeKia"},
          {name: "Land Rover", stateName: "makeLandRover"},
          {name: "Chevrolet", stateName: "makeChevrolet"},
          {name: "Lexus", stateName: "makeLexus"},
          {name: "Mercedes", stateName: "makeMercedes"},
          {name: "Nissan", stateName: "makeNissan"},
          {name: "Ford", stateName: "makeFord"},
          {name: "Infiniti", stateName: "makeInfiniti"},
          {name: "Hyundai", stateName: "makeHyundai"},
          {name: "Lincoln", stateName: "makeLincoln"},
          {name: "Jaguar", stateName: "makeJaguar"},
          {name: "Volkswagen", stateName: "makeVolkswagen"},
          {name: "Alfa Romeo", stateName: "makeAlfaRomeo"},
        ],
      };
    }
  }

  selectTab () {
    console.log('location' + this.props.location.pathname);
  }

  componentWillMount() {
      //sessionStorage.getItem('currentRestaurantId') ? this.fetchMenuList() : false;
      //this.fetchDeals();
      //console.log('now mounting HomeTabs. this.props.topDeals: ' + this.props.topDeals);
      //if (this.props.leasyZip != '') {
      //  this.fetchTopDeals();
      //}
      // const { topDeals } = this.props;
      // if (topDeals.length > 0 ) {
      //   this.classifyDeals(topDeals);
      // }


      ReactGA.initialize('UA-107081605-2');
      ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentDidMount() {
    // console.log('in componentDidMount for FilteredDeals...star1 in localStorage: ' + localStorage.getItem('star1'));
    // console.log('star1 in state: ' + this.state.star1);
    // this.setState({
    //   star1: (localStorage.getItem('star1') === null) ? this.state.star1 : localStorage.getItem('star1'),
    //   star2: (localStorage.getItem('star2') !== null) ? localStorage.getItem('star2') : this.state.star2
    // }, () => {
    //
    // });

    this.recalculateFilteredDeals();
  }

  componentWillUnmount() {
    //console.log('unmounting for FilteredDeals...');
    this.saveStateToLocalStorage();
  }

  // static getDerivedStateFromProps(props, state) {
  //   //console.log('in getDerivedStateFromProps()..');
  //   if (state.allLocalDeals !== props.allLocalDeals) {
  //     return {
  //       allLocalDeals: props.allLocalDeals,
  //       resultingDeals: props.allLocalDeals,
  //     }
  //     return null
  //   }
  // }

  componentDidUpdate(prevProps, prevState, snapshot) {
    //console.log('in componentDidUpdate for FilteredDeals...');
    const { allLocalDeals } = this.props;

    if (allLocalDeals !== prevProps.allLocalDeals ) {
      //console.log('props changed...');
      this.setState({
        allLocalDeals: allLocalDeals,
      }, () => {
        this.recalculateFilteredDeals();
      });
    }

    // if (prevState.resultingDeals !== this.state.resultingDeals) {
    //   console.log('resultingDeals changed');
    // }
  }

  loadStateFromLocalStorage = () => {

  }


  saveStateToLocalStorage = () => {
    sessionStorage.setItem('star1', this.state.star1);
    sessionStorage.setItem('star2', this.state.star2);
    sessionStorage.setItem('star3', this.state.star3);
    sessionStorage.setItem('star4', this.state.star4);
    sessionStorage.setItem('star5', this.state.star5);

    sessionStorage.setItem('maxPayment', this.state.maxPayment);
    sessionStorage.setItem('bodyTypeSedan', this.state.bodyTypeSedan);
    sessionStorage.setItem('bodyTypeCoupe', this.state.bodyTypeCoupe);
    sessionStorage.setItem('bodyTypeConvertible', this.state.bodyTypeConvertible);
    sessionStorage.setItem('bodyTypeSUV', this.state.bodyTypeSUV);
    sessionStorage.setItem('bodyTypeHatchback', this.state.bodyTypeHatchback);
    sessionStorage.setItem('bodyTypeMinivan', this.state.bodyTypeMinivan);
    sessionStorage.setItem('bodyTypeTruck', this.state.bodyTypeTruck);

    sessionStorage.setItem('typeHydrogenFuelCell', this.state.typeHydrogenFuelCell);
    sessionStorage.setItem('typeElectric', this.state.typeElectric);
    sessionStorage.setItem('typeHybrid', this.state.typeHybrid);
    sessionStorage.setItem('typeGasoline', this.state.typeGasoline);

    sessionStorage.setItem('sortOrder', this.state.sortOrder);

    sessionStorage.setItem('makeHonda', this.state.makeHonda);
    sessionStorage.setItem('makeToyota', this.state.makeToyota);
    sessionStorage.setItem('makeAudi', this.state.makeAudi);
    sessionStorage.setItem('makeBMW', this.state.makeBMW);
    sessionStorage.setItem('makeChevrolet', this.state.makeChevrolet);
    sessionStorage.setItem('makeKia', this.state.makeKia);
    sessionStorage.setItem('makeLandRover', this.state.makeLandRover);
    sessionStorage.setItem('makeVolkswagen', this.state.makeVolkswagen);
    sessionStorage.setItem('makeLexus', this.state.makeLexus);
    sessionStorage.setItem('makeNissan', this.state.makeNissan);
    sessionStorage.setItem('makeFord', this.state.makeFord);
    sessionStorage.setItem('makeInfiniti', this.state.makeInfiniti);
    sessionStorage.setItem('makeMercedes', this.state.makeMercedes);
    sessionStorage.setItem('makeHyundai', this.state.makeHyundai);
    sessionStorage.setItem('makeLincoln', this.state.makeLincoln);
    sessionStorage.setItem('makeJaguar', this.state.makeJaguar);
    sessionStorage.setItem('makeAcura', this.state.makeAcura);
    sessionStorage.setItem('makeAlfaRomeo', this.state.makeAlfaRomeo);
    sessionStorage.setItem('searchByMakeModel', this.state.searchByMakeModel);
  }


    handleDrawerToggle = () => {
      this.setState({ mobileOpen: !this.state.mobileOpen });
    };

    handleRatingCheckboxChange = name => event => {
      //console.log('in handleRatingCheckboxChange: ' + name);
      this.setState({ [name]: event.target.checked
      }, () => {
        this.clearQueryParam();
        this.recalculateFilteredDeals();
      });
    };

    handleMakeCheckboxChange = name => event => {
      this.setState({ carMakes: {
        ...this.state.carMakes,
        [name]: event.target.checked,
      }}, () => {
        this.clearQueryParam();
        this.recalculateFilteredDeals();
      });
    };

    handleChange = name => event => {
      this.setState({
        [name]: event.target.value,
      }, () => {
        if (name === "maxPayment" && this.state.maxPayment >= 10) {
          //console.log('recalculateFilteredDeals...');
          this.clearQueryParam();
          this.recalculateFilteredDeals();
        }
        if (name === "sortOrder")
          this.recalculateFilteredDeals();
        if (name === "searchByMakeModel")
          this.clearQueryParam();
          this.recalculateFilteredDeals();
        // if (name === "searchByMakeModel" && this.state.searchByMakeModel.length === 0) //reset search
        //   this.recalculateFilteredDeals();
      });
    };

    clearQueryParam = () => {
      const history = createBrowserHistory();
      history.push('/explore/');
    }

    handleClearButtonPress = event => {
      console.log('button pressed');
      this.clearQueryParam();
      this.setState({
        //filter fields
        star1: true,
        star2: true,
        star3: true,
        star4: true,
        star5: true,
        maxPayment: 2000,
        bodyTypeSedan: true,
        bodyTypeCoupe: true,
        bodyTypeConvertible: true,
        bodyTypeSUV: true,
        bodyTypeHatchback: true,
        bodyTypeMinivan: true,
        bodyTypeTruck: true,
        //type params
        typeHydrogenFuelCell: true,
        typeElectric: true,
        typeHybrid: true,
        typeGasoline: true,
        sortOrder: "rating", //or "rating"
        makeHonda: true,
        makeToyota: true,
        makeAudi: true,
        makeBMW: true,
        makeChevrolet: true,
        makeKia: true,
        makeLandRover: true,
        makeVolkswagen: true,
        makeLexus: true,
        makeNissan: true,
        makeFord: true,
        makeInfiniti: true,
        makeMercedes: true,
        makeHyundai: true,
        makeLincoln: true,
        makeJaguar: true,
        makeAcura: true,
        makeAlfaRomeo: true,
        searchByMakeModel: '',
      }, () => {
        this.recalculateFilteredDeals();
      });
    }

    compareDeals = (a, b) => {
      if (!this.state) {
        if (parseInt(a.valueScore) < parseInt(b.valueScore)) {
          return -1;
        }
        if (parseInt(a.valueScore) > parseInt(b.valueScore)) {
          return 1;
        }
        return 0;
      }

      if (this.state.sortOrder === "rating") {
        if (parseInt(a.valueScore) < parseInt(b.valueScore)) {
          return -1;
        }
        if (parseInt(a.valueScore) > parseInt(b.valueScore)) {
          return 1;
        }
        return 0;
      } else {
        if (parseInt(removeDollarSignAndCommas(a.leaseMonthlyPayment)) < parseInt(removeDollarSignAndCommas(b.leaseMonthlyPayment))) {
          return -1;
        }
        if (parseInt(removeDollarSignAndCommas(a.leaseMonthlyPayment)) > parseInt(removeDollarSignAndCommas(b.leaseMonthlyPayment))) {
          return 1;
        }
        return 0;
      }
    }

    compareByPayment = (a, b) => {
      if (parseInt(removeDollarSignAndCommas(a.leaseMonthlyPayment)) < parseInt(removeDollarSignAndCommas(b.leaseMonthlyPayment))) {
        return -1;
      } else {
        return 1;
      }
      return 0;
    }

    compareByRating = (a, b) => {
      if (parseInt(a.valueScore) >= parseInt(b.valueScore)) {
        return -1;
      } else {
        return 1;
      }
      return 0;
    }

    recalculateFilteredDeals() {
      //console.log('in recalculateFilteredDeals()');
      // this.setState({
      //   resultingDeals: []
      // });
      if (!this.state.allLocalDeals)
        return;

      let results = [];
      //console.log('len of allLocalDeals: ' + this.state.allLocalDeals.length);
      for (var i=0; i < this.state.allLocalDeals.length; i++) {
        let vs = parseInt(this.state.allLocalDeals[i].valueScore);
        if (this.state.star1) {
          if (vs > 140)
            results.push(this.state.allLocalDeals[i]);
        }
        if (this.state.star2) {
          if (vs > 120 && vs <= 140)
            results.push(this.state.allLocalDeals[i]);
        }
        if (this.state.star3) {
          if (vs > 100 && vs <= 120)
            results.push(this.state.allLocalDeals[i]);
        }
        if (this.state.star4) {
          if (vs > 90 && vs <= 100)
            results.push(this.state.allLocalDeals[i]);
        }
        if (this.state.star5) {
          if (vs <= 90)
            results.push(this.state.allLocalDeals[i]);
        }
      }


      //maxPayment filter
      let maxPayment = this.state.maxPayment;
      let maxPaymentResults = [];
      for (var i=0; i < results.length; i++) {
        if (maxPayment > 10) {
          if (parseInt(maxPayment) >= parseInt(removeDollarSignAndCommas(results[i].leaseMonthlyPayment))) {
            maxPaymentResults.push(results[i]);
          }
        } else {
          maxPaymentResults.push(results[i]);
        }
      }

      //bodyStyle AND poweredBy filter

      let bodyStyleResults = [];
      for (var i=0; i < maxPaymentResults.length; i++) {
        for(var j=0; j < maxPaymentResults[i].tags.length; j++) {
          if (maxPaymentResults[i].tags[j] === "sedan" && this.state.bodyTypeSedan) {
            bodyStyleResults.push(maxPaymentResults[i]);
            break;
          }
          if (maxPaymentResults[i].tags[j] === "coupe" && this.state.bodyTypeCoupe) {
            bodyStyleResults.push(maxPaymentResults[i]);
            break;
          }
          if (maxPaymentResults[i].tags[j] === "convertible" && this.state.bodyTypeConvertible) {
            bodyStyleResults.push(maxPaymentResults[i]);
            break;
          }
          if (maxPaymentResults[i].tags[j] === "suv" && this.state.bodyTypeSUV) {
            bodyStyleResults.push(maxPaymentResults[i]);
            break;
          }
          if (maxPaymentResults[i].tags[j] === "hatchback" && this.state.bodyTypeHatchback) {
            bodyStyleResults.push(maxPaymentResults[i]);
            break;
          }
          if (maxPaymentResults[i].tags[j] === "minivan" && this.state.bodyTypeMinivan) {
            bodyStyleResults.push(maxPaymentResults[i]);
            break;
          }
          if (maxPaymentResults[i].tags[j] === "truck" && this.state.bodyTypeTruck) {
            bodyStyleResults.push(maxPaymentResults[i]);
            break;
          }
          //also including the poweredBy filter here

        }
        //special case for sedans as we don't have all the deals with tags
        // add deals that don't have any tags as sedans
        if (maxPaymentResults[i].tags.length === 0) {
          if (this.state.bodyTypeSedan)
            bodyStyleResults.push(maxPaymentResults[i]);
        }
      }

      //type (gasoline/electric) filter
      let typeResults = [];
      for (var i=0; i < bodyStyleResults.length; i++) {
        for(var j=0; j < bodyStyleResults[i].tags.length; j++) {
          if (maxPaymentResults[i].tags[j] === "gasoline" && this.state.typeGasoline) {
            typeResults.push(bodyStyleResults[i]);
            break;
          }
          if (maxPaymentResults[i].tags[j] === "hybrid" && this.state.typeHybrid) {
            typeResults.push(bodyStyleResults[i]);
            break;
          }
          if (maxPaymentResults[i].tags[j] === "electric" && this.state.typeElectric) {
            typeResults.push(bodyStyleResults[i]);
            break;
          }
          if (maxPaymentResults[i].tags[j] === "hydrogenFuelCell" && this.state.typeHydrogenFuelCell) {
            typeResults.push(bodyStyleResults[i]);
            break;
          }
        }
      }

      //car makes filter
      let carMakesResults = [];
      for (var i=0; i < typeResults.length; i++) {
        if (this.state.searchByMakeModel.length > 0) {
          if (typeResults[i].make.toUpperCase().includes(this.state.searchByMakeModel.toUpperCase())) {
            //console.log('make: ' + bodyStyleResults[i].make);
            carMakesResults.push(typeResults[i]);
            //console.log(('carMakesResults len:' + carMakesResults.length));
          }
          //now for the model
          if (typeResults[i].model.toUpperCase().includes(this.state.searchByMakeModel.toUpperCase())) {
            //console.log('model: ' + bodyStyleResults[i].model);
            carMakesResults.push(typeResults[i]);
          }
        } else {
          //now handle the make checkboxes
          if(this.state['make' + capitalizeFirstLetter(typeResults[i].make)])
            carMakesResults.push(typeResults[i]);
        }


      }

      //TODO: need to move this to the end
      // if (carMakesResults.length > 100) {
      //   carMakesResults = carMakesResults.slice(0,100)
      // }
      //
      // //now lets sort it
      // const finalResult = carMakesResults.sort(this.compareDeals);
      const finalResult = this.sortAndSlice(carMakesResults);

      // if (this.state.sortOrder === "rating")
      //   const finalResult = bodyStyleResults.sort(this.compareByRating);
      // else
      //   const finalResult = bodyStyleResults.sort(this.compareByPayment);

      //console.log(JSON.stringify(carMakesResults));

      this.setState({
        resultingDeals: finalResult
      });
    }

  sortAndSlice = (list) => {
    //TODO: need to move this to the end
    if (list) {
      list.sort(this.compareDeals);
      let l = [];
      if (list.length > 100) {
        l = list.slice(0,100)
      } else {
        l = list;
      }
      return l;
    } else {
      return [];
    }

  }


  render() {
    const { classes, theme, leasyZip } = this.props;
    const { carMakes, resultingDeals } = this.state;
    let fontSize = "small";

    let star1 = [<StarIcon fontSize={fontSize} key={1}/>, <StarBorder fontSize={fontSize} key={2}/>, <StarBorder fontSize={fontSize} key={3}/>, <StarBorder fontSize={fontSize} key={4}/>, <StarBorder fontSize={fontSize} key={5}/>];
    let star2 = [<StarIcon fontSize={fontSize} key={1}/>, <StarIcon fontSize={fontSize} key={2}/>, <StarBorder fontSize={fontSize} key={3}/>, <StarBorder fontSize={fontSize} key={4}/>, <StarBorder fontSize={fontSize} key={5}/>];
    let star3 = [<StarIcon fontSize={fontSize} key={1}/>, <StarIcon fontSize={fontSize} key={2}/>, <StarIcon fontSize={fontSize} key={3}/>, <StarBorder fontSize={fontSize} key={4}/>, <StarBorder fontSize={fontSize} key={5}/>];
    let star4 = [<StarIcon fontSize={fontSize} key={1}/>, <StarIcon fontSize={fontSize} key={2}/>, <StarIcon fontSize={fontSize} key={3}/>, <StarIcon fontSize={fontSize} key={4}/>, <StarBorder fontSize={fontSize} key={5}/>];
    let star5 = [<StarIcon fontSize={fontSize} key={1}/>, <StarIcon fontSize={fontSize} key={2}/>, <StarIcon fontSize={fontSize} key={3}/>, <StarIcon fontSize={fontSize} key={4}/>, <StarIcon fontSize={fontSize} key={5}/>];



    const filterDrawer = (
      <FormControl component="fieldset" className={classes.formControl}>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"

          >
            <Typography className={classes.heading}>Lease Offer Rating</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormGroup>
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.star1}
                      onChange={this.handleRatingCheckboxChange('star1')}
                      value="star1"
                      color="primary"
                    />
                  }
                  label={star1}
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.star2}
                      onChange={this.handleRatingCheckboxChange('star2')}
                      value="star2"
                      color="primary"
                    />
                  }
                  label={star2}
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.star3}
                      onChange={this.handleRatingCheckboxChange('star3')}
                      value="star3"
                      color="primary"
                    />
                  }
                  label={star3}
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.star4}
                      onChange={this.handleRatingCheckboxChange('star4')}
                      value="star4"
                      color="primary"
                    />
                  }
                  label={star4}
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.star5}
                      onChange={this.handleRatingCheckboxChange('star5')}
                      value="star5"
                      color="primary"
                    />
                  }
                  label={star5}
                />
            </FormGroup>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>Monthly Payment</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormControl className={classes.formControl}>
            <TextField
              id="outlined-adornment-amount"

              variant="outlined"
              label="Max Payment"
              value={this.state.maxPayment}
              onChange={this.handleChange('maxPayment')}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
            />
            </FormControl>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>Body Style</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormGroup>
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.bodyTypeSedan}
                      onChange={this.handleRatingCheckboxChange('bodyTypeSedan')}
                      value="bodyTypeSedan"
                      color="primary"
                    />
                  }
                  label="Sedan"
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.bodyTypeCoupe}
                      onChange={this.handleRatingCheckboxChange('bodyTypeCoupe')}
                      value="bodyTypeCoupe"
                      color="primary"
                    />
                  }
                  label="Coupe"
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.bodyTypeConvertible}
                      onChange={this.handleRatingCheckboxChange('bodyTypeConvertible')}
                      value="bodyTypeConvertible"
                      color="primary"
                    />
                  }
                  label="Convertible"
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.bodyTypeSUV}
                      onChange={this.handleRatingCheckboxChange('bodyTypeSUV')}
                      value="bodyTypeSUV"
                      color="primary"
                    />
                  }
                  label="SUV"
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.bodyTypeHatchback}
                      onChange={this.handleRatingCheckboxChange('bodyTypeHatchback')}
                      value="bodyTypeHatchback"
                      color="primary"
                    />
                  }
                  label="Hatchback"
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.bodyTypeMinivan}
                      onChange={this.handleRatingCheckboxChange('bodyTypeMinivan')}
                      value="bodyTypeMinivan"
                      color="primary"
                    />
                  }
                  label="Minivan"
                />
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.bodyTypeTruck}
                      onChange={this.handleRatingCheckboxChange('bodyTypeTruck')}
                      value="bodyTypeTruck"
                      color="primary"
                    />
                  }
                  label="Truck"
                />
            </FormGroup>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>Make</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <Grid container alignItems="stretch" justify="left" spacing={0}>
            { carMakes && carMakes.map((data, i) =>
              <Grid item xs={6}>
                  <FormGroup>
                    <FormControlLabel
                        control={
                          <Checkbox
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checked={this.state[data.stateName]}
                            onChange={this.handleRatingCheckboxChange(data.stateName)}
                            value={data.stateName}
                            color="primary"
                          />
                        }
                        label={data.name}
                      />
                  </FormGroup>
              </Grid>
            )}
          </Grid>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>Type</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <FormGroup>
            <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.typeGasoline}
                    onChange={this.handleRatingCheckboxChange('typeGasoline')}
                    value="typeGasoline"
                    color="primary"
                  />
                }
                label="Gasoline"
              />
            <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.typeHybrid}
                    onChange={this.handleRatingCheckboxChange('typeHybrid')}
                    value="typeHybrid"
                    color="primary"
                  />
                }
                label="Hybrid"
              />
            <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.typeElectric}
                    onChange={this.handleRatingCheckboxChange('typeElectric')}
                    value="typeElectric"
                    color="primary"
                  />
                }
                label="Electric"
              />
            <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.typeHydrogenFuelCell}
                    onChange={this.handleRatingCheckboxChange('typeHydrogenFuelCell')}
                    value="typeHydrogenFuelCell"
                    color="primary"
                  />
                }
                label="Hydrogen Fuel-Cell"
              />
          </FormGroup>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>Sort By</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormControl component="fieldset" className={classes.formControl}>
              <RadioGroup
                aria-label="sortOrder"
                name="sortOrder"
                className={classes.group}
                value={this.state.sortOrder}
                onChange={this.handleChange('sortOrder')}
              >
                <FormControlLabel value="rating" control={<Radio />} label="HipKar Deal Rating" />
                <FormControlLabel value="payment" control={<Radio />} label="Monthly Payment" />
              </RadioGroup>
            </FormControl>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <Grid container alignItems="stretch" justify="right" align="right" spacing={0}>
          <Grid item xs={12}>
            <Button size="small" color="primary" className={classes.button} onClick={this.handleClearButtonPress}>
              Clear All Filters
            </Button>
          </Grid>
        </Grid>
      </FormControl>
    );

    return (
        <div className={classes.root}>
          <Grid container alignItems="stretch" justify="center" spacing={0}>
            <Grid item xs={0} sm={0} md={0} lg={2}>
            </Grid>
            <Grid item xs={0} sm={0} md={0} lg={2}>
              <div className={classes.content}>
                <Hidden lgUp>
                  <Drawer
                    variant="temporary"
                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                    open={this.state.mobileOpen}
                    classes={{
                      paper: classes.drawerPaper,
                    }}
                    onClose={this.handleDrawerToggle}
                    ModalProps={{
                      keepMounted: true, // Better open performance on mobile.
                    }}
                  >
                    {filterDrawer}
                  </Drawer>
                </Hidden>
                <Hidden mdDown>
                  <Drawer
                    classes={{
                      paper: classes.drawerPaperFilter,
                    }}
                    variant="permanent"
                    open
                  >
                    {filterDrawer}
                  </Drawer>
                </Hidden>
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={6}>
              <main className={classes.content}>
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={this.handleDrawerToggle}
                    className={classes.navIconHide}
                  >
                    <FilterListIcon />
                  </IconButton>
                  <TextField
                    id="outlined-name"
                    label="Search by make or model"
                    className={classes.textField}
                    value={this.state.searchByMakeModel}
                    onChange={this.handleChange('searchByMakeModel')}
                    margin="normal"
                    variant="outlined"
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                    }}
                  />
                  <TabContainer><DealTiles list={resultingDeals} leasyZip={leasyZip}/></TabContainer>
              </main>
            </Grid>
            <Grid item xs={0} sm={0} md={0} lg={2}>
            </Grid>
          </Grid>

        </div>
    );
  }
}

FilteredDeals.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(FilteredDeals);



// WEBPACK FOOTER //
// ./src/components/dashboard/FilteredDeals.jsx